import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';

// Antall bud per oppdrag, {orderId: antall}. Én lytter per oppdrag (reglene for bids
// avhenger av oppdragets ordererUid, så en `in`-spørring er ikke trygg). Oppdrag uten
// verdi i resultatet har ikke svart ennå (eller feilet).
export function useBidCounts(orderIds) {
  const [counts, setCounts] = useState({});
  const key = [...new Set(orderIds)].sort().join('|');

  useEffect(() => {
    const ids = key ? key.split('|') : [];
    setCounts({});
    const unsubs = ids.map(orderId => onSnapshot(
      query(collection(db, 'bids'), where('orderId', '==', orderId)),
      snap => setCounts(prev => ({ ...prev, [orderId]: snap.size })),
      err => console.error('[useBidCounts]', orderId, err)
    ));
    return () => unsubs.forEach(u => u());
  }, [key]);

  return counts;
}
